export default {"src":"/_next/static/media/info-circle.a6b305c1.svg","height":20,"width":20};